import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { pageReloadAuth } from '../Reducer/AuthReducer'
import store from '../Store/store'

export const AutoLogout = (): null => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        const logoutTimer = setTimeout(
            () => {
                localStorage.clear()
                dispatch(pageReloadAuth())
                setTimeout(() => {
                    navigate(`/`)
                    window.location.reload()
                }, 1000)
            },
            30 * 60 * 1000
        )

        return () => {
            clearTimeout(logoutTimer)
        } // Cleanup timeout on unmount
    }, [])

    return null
}

export const AutoLogoutwithoutTime = (): void => {
    localStorage.clear()
    store.dispatch(pageReloadAuth())
    window.location.reload()
    // Redirect to home or login
    window.location.href = '/' // or '/login'
}
